window.initUploadFile = function () {
    // file upload
    $('.js-file-upload-input').off('change').change(function () {
        const value = $(this).val();

        const printFilename = (filename) => {
            const template = `
				<div class="file-upload__item js-file-upload-item">
					<div class="file-upload__name">${filename}</div>
					<div class="file-upload__delete js-file-upload-delete">х</div>
				</div>
			`;
            $(this).parents('.js-file-upload').find('.js-file-upload-result').html(template);
        }

        if (value) {
            const filename = value.match(/[^\\/]*$/)[0];
            printFilename(filename);
        }
    });

    $('.js-file-upload-result').on('click', '.js-file-upload-delete', function () {
        $(this).parents('.js-file-upload-item').remove();
        $('input[type="file"]').val(null);
    });
}

initUploadFile();
        